module.exports = __webpack_public_path__ + "static/media/order_warning.b199a8dc.svg";